import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { country } from '../../enums/language';
import { LanguageService } from '../../services/language.service';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-virtual-keyboard',
  templateUrl: './virtual-keyboard.component.html',
  styleUrls: ['./virtual-keyboard.component.css'],
})
export class VirtualKeyboardComponent {
  images = { 
    CROSS: CROSS,
  }
  @Input() showDecimal: boolean = true;
  @Input() showTripleZeros: boolean = false;
  @Output() numberEntered = new EventEmitter<string>();
  @Output() numBackClicked = new EventEmitter<string>();
  @Output() decimalClicked = new EventEmitter<string>();
  indoSpecific;

  constructor(
    private languageService : LanguageService
  ) {
    this.indoSpecific = this.languageService.getCountry() === country.id.country;
  }

  getNumber(e) {
    if (e.target.attributes._key.value === '12') {
      this.numBackClicked.emit('back clicked');
    } else if (e.target.attributes._key.value === '11') {
      if (!this.indoSpecific) this.decimalClicked.emit('.');
      else this.decimalClicked.emit(',');
    } else if (
      e.target.attributes._key.value !== '11' &&
      e.target.attributes._key.value !== '12'
    ) {
      this.numberEntered.emit(e.target.attributes._key.value);
    }
  }
}
